export default {"src":"/_next/static/media/Skin-Cancer-icon.7c2763aa.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};